// extracted by mini-css-extract-plugin
module.exports = {"innerContainer":"ScrollIndicator_innerContainer__ms8RV","upSvg":"ScrollIndicator_upSvg__2kQ5_","downSvg":"ScrollIndicator_downSvg__m551u"};